/* Accessible focus for the native header panels; native opening/AJAX remain in theme.js. */
(function () {
  'use strict';
  if (window.mtDiscoveryController) {
    window.mtDiscoveryController.mount();
    return;
  }

  const mounted = new WeakSet();
  const dialogs = [];
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]';

  function visible(element) {
    return element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== 'hidden';
  }

  function initialise(panel, kind) {
    if (mounted.has(panel)) return;
    mounted.add(panel);
    const header = panel.closest('.header');
    const triggers = Array.from(header.querySelectorAll(kind === 'menu' ? '.toggle-panel-button' : '.action-search'));
    const openClass = kind === 'menu' ? 'site-panel-open' : 'quick-search-open';
    const section = panel.closest('.shopify-section');
    let open = false;
    let opener = null;
    let focusFrame = null;
    if (!panel.id) panel.id = 'mt-' + kind + '-' + (section ? section.id : 'header');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', kind === 'menu' ? 'Main menu' : 'Search watches');
    panel.tabIndex = -1;
    triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', function () { opener = trigger; }, true);
    });

    function targets() {
      return Array.from(panel.querySelectorAll(focusable)).filter(visible);
    }

    function focusInside(attempt) {
      if (!open || !panel.isConnected || panel.contains(document.activeElement)) return;
      const preferred = panel.querySelector('input[type="search"]');
      const target = preferred && visible(preferred) ? preferred : targets()[0];
      if (target) target.focus();
      // The native menu becomes visible during its opening transition.
      // Retry for that bounded interval, and stop if it closes or focus arrives.
      if (!panel.contains(document.activeElement) && attempt < 20) {
        focusFrame = window.requestAnimationFrame(function () { focusInside(attempt + 1); });
      }
    }

    function sync() {
      if (!panel.isConnected) return;
      const next = document.documentElement.classList.contains(openClass);
      panel.inert = !next;
      panel.setAttribute('aria-hidden', String(!next));
      if (next) panel.setAttribute('aria-modal', 'true');
      else panel.removeAttribute('aria-modal');
      triggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', String(next)); });
      if (next === open) return;
      open = next;
      if (focusFrame !== null) window.cancelAnimationFrame(focusFrame);
      if (open) {
        if (!opener) opener = triggers.find(visible) || null;
        focusFrame = window.requestAnimationFrame(function () { focusInside(0); });
      } else if (opener && opener.isConnected && visible(opener) && (panel.contains(document.activeElement) || document.activeElement === document.body)) {
        opener.focus();
      }
    }

    panel.addEventListener('keydown', function (event) {
      if (!open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        document.documentElement.classList.remove(openClass);
        sync();
      } else if (event.key === 'Tab') {
        const nodes = targets();
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (!first) {
          event.preventDefault();
          panel.focus();
        } else if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel)) {
          event.preventDefault();
          first.focus();
        }
      }
    });
    dialogs.push(sync);
    sync();
  }

  function mount() {
    document.querySelectorAll('.header .site-panel').forEach(function (panel) { initialise(panel, 'menu'); });
    document.querySelectorAll('.header .quick-search').forEach(function (panel) { initialise(panel, 'search'); });
  }
  window.mtDiscoveryController = { mount: mount };
  new MutationObserver(function () { dialogs.forEach(function (sync) { sync(); }); }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
}());

/* Two useful product views on touch screens. The native product link and bag
   form remain independent; a horizontal swipe suppresses only its own click. */
(function () {
  'use strict';
  if (window.mtCardViewController) {
    window.mtCardViewController.mount();
    return;
  }
  const mounted = new WeakSet();
  function mount() {
    document.querySelectorAll('[data-mt-card-gallery]').forEach(function (card) {
      if (mounted.has(card)) return;
      const photo = card.querySelector('.mt-hcard__photo-link');
      const button = card.querySelector('[data-mt-card-view]');
      const counter = card.querySelector('[data-mt-card-counter]');
      if (!photo || !button) return;
      mounted.add(card);
      let start = null;
      let suppressClick = false;
      function toggle() {
        const alternate = card.dataset.mtAlternate !== 'true';
        card.dataset.mtAlternate = String(alternate);
        button.setAttribute('aria-pressed', String(alternate));
        if (counter) counter.textContent = alternate ? '2 / 2' : '1 / 2';
      }
      button.addEventListener('click', toggle);
      photo.addEventListener('pointerdown', function (event) {
        suppressClick = false;
        start = event.pointerType === 'touch' ? { x:event.clientX, y:event.clientY, id:event.pointerId } : null;
      }, { passive:true });
      photo.addEventListener('pointerup', function (event) {
        if (!start || start.id !== event.pointerId) return;
        const horizontal = Math.abs(event.clientX - start.x);
        const vertical = Math.abs(event.clientY - start.y);
        if (horizontal > 32 && horizontal > vertical * 1.5) {
          suppressClick = true;
          toggle();
        }
        start = null;
      }, { passive:true });
      photo.addEventListener('pointercancel', function () { start = null; }, { passive:true });
      photo.addEventListener('click', function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      }, true);
      button.hidden = false;
      card.dataset.mtCardReady = 'true';
    });
  }
  window.mtCardViewController = { mount:mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once:true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
}());
